import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_108: FaireProductEntity = {
  token: "catalog_prod_prod-108",
  type: "product",
  name: "Textile Item - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=400&fit=crop",
  priceDollars: 21.6,
  msrpDollars: 54,
  sku: "CA0108",
  caseSize: 4,
  material: "Wood",
  collectionToken: "col_camp",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: true,
  inStock: true,
  stockLevel: 461,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["catalog_cat_coffee-tea"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
